/**
 * 几何体交互状态枚举。
 */
export enum GeometryInteractionState {
    /** 默认状态。 */
    Default = 'default',
    /** 悬浮状态。 */
    Hover = 'hover',
    /** 选中状态。 */
    Selected = 'selected',
    /** 创建状态。 */
    Creating = 'creating',
}